import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { ToastContainerComponent } from './toast/toast-container/toast-container.component';
import {
  animate,
  group,
  query,
  style,
  transition,
  trigger,
} from '@angular/animations';
import { PosthogService } from './services/posthog.service';
import { AnalyticsIdentityService } from './services/analytics-identity.service';

@Component({
  standalone: true,
  selector: 'app-root',
  imports: [RouterOutlet, ToastContainerComponent],
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
  animations: [
    trigger('routeAnimations', [
      transition('* <=> *', [
        // Ensure the leaving and entering pages can be animated together.
        query(
          ':enter, :leave',
          [
            style({
              position: 'absolute',
              top: 0,
              left: 0,
              width: '100%',
            }),
          ],
          { optional: true }
        ),

        query(
          ':enter',
          [style({ opacity: 0, transform: 'translateY(12px)' })],
          { optional: true }
        ),

        group([
          query(
            ':leave',
            [
              animate(
                '180ms ease',
                style({ opacity: 0, transform: 'translateY(-6px)' })
              ),
            ],
            { optional: true }
          ),
          query(
            ':enter',
            [
              animate(
                '220ms ease',
                style({ opacity: 1, transform: 'translateY(0)' })
              ),
            ],
            { optional: true }
          ),
        ]),
      ]),
    ]),
  ],
})
export class AppComponent {
  constructor(
    private posthogService: PosthogService,
    private identity: AnalyticsIdentityService
  ) {
    this.identity.init(); // ← dentro del constructor
  }
}
